import { tagGroups } from '@/mocks/home';
import Reveal from '@/pages/home/components/Reveal';
import SectionHeading from '@/pages/home/components/SectionHeading';

type TagDirectoryProps = {
  query: string;
};

export default function TagDirectory({ query }: TagDirectoryProps) {
  const keyword = query.trim().toLowerCase();

  const groups = tagGroups
    .map((group) => ({
      ...group,
      tags: keyword ? group.tags.filter((tag) => tag.toLowerCase().includes(keyword)) : group.tags,
    }))
    .filter((group) => group.tags.length > 0);

  return (
    <section id="tags" className="py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="标签目录"
            icon="ri-price-tag-3-line"
            title="按维度筛，标签目录就是你的索引页"
            desc="标签按人物、事件、地区、题材、形式分成五组。想找某个具体角度，不用先确定栏目，直接在目录里点标签即可进入对应入口。"
          />
        </Reveal>

        {groups.length === 0 ? (
          <div className="mt-8 rounded-lg border border-dashed border-background-300 bg-background-100 px-6 py-12 text-center">
            <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-background-50 text-foreground-400">
              <i className="ri-price-tag-2-line text-xl"></i>
            </span>
            <p className="mt-3 text-sm text-foreground-600">
              标签目录里没有匹配「{query}」的条目，试着输入栏目名或换个更短的关键词。
            </p>
          </div>
        ) : (
          <div className="mt-9 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
            {groups.map((group, index) => (
              <Reveal key={group.id} delay={index * 50}>
                <div className="h-full rounded-lg border border-background-200 bg-background-100 p-5">
                  <div className="flex items-center gap-2.5">
                    <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                      <i className={`${group.icon} text-base`}></i>
                    </span>
                    <h3 className="font-heading text-base font-semibold text-foreground-950">
                      {group.title}
                    </h3>
                    <span className="ml-auto text-[11px] text-foreground-500">
                      {group.tags.length} 个
                    </span>
                  </div>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {group.tags.map((tag) => (
                      <a
                        key={tag}
                        href="#featured"
                        className="whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-secondary-400 hover:bg-secondary-100 hover:text-secondary-900"
                      >
                        {tag}
                      </a>
                    ))}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}